module.exports = __webpack_public_path__ + "img/logo-finalized.53f6da0f.png";